
export type TransmitChannelName = 'refresh' | 'filter_lawyer' | 'notification' | 'snackbar-message' | 'page' | 'response' | 'page-loading' | 'screen-mode' | 'boot-info' | 'user-apps' | 'notify-component-response' | 'notify-component-action-click' | 'page-component-params' | 'alert-message' | 'notify-component-response' | 'notifications-overall' | 'profile-data' | 'file_pk' | 'consultation-filter' | 'bank-list' | 'no-pad' | 'no-sideBar' | 'no-footer' | 'errorLog' | 'videoHasError' | 'has-sideBar' | 'special-products' | 'refresh-question-list' | 'comment-filter' | 'filter_user' | 'config_value' | 'goftino_ready' | 'charge_wallet';



export type Direction = 'rtl' | 'ltr';

export type GenericLocaleNamespace = 'units' | 'auth' | 'common' | 'desktop' | 'msgs' | 'widgets' | 'notification';

export type AvailableLanguage = 'fa' | 'en';

export type LocaleCalendar = 'jalali' | 'gregorian' | 'auto';

export type productNames = 'petition' | 'learning' | 'smart_contract' | 'ready_contract' | 'custom_contract';

export enum NotifyDelay {
    SHORT = 2000,
    MEDIUM = 3500,
    LONG = 5000,
}

export type ScreenMode = 'desktop' | 'tablet' | 'mobile';

export type NotificationMode = 'info' | 'warning' | 'success' | 'error';


export type WindowResizeMode = 'horizontal' | 'vertical' | 'both' | 'bothTop' | 'none';

export type CurrencyType = 'iran_rial' | 'toman' | 'us_dollar' | 'euro' | 'indian_rupee' | 'pound' | 'franc' | 'lira' | 'dinar';

export const CurrencyTypes: CurrencyType[] = ['iran_rial', 'toman', 'us_dollar', 'euro', 'indian_rupee', 'pound', 'franc', 'lira', 'dinar'];


export const AudioMimeTypes = ['audio/mp3', 'audio/wav', 'audio/mpeg'];
export const ImageMimeTypes = ['image/png', 'image/jpeg', 'image/gif'];
export const VideoMimeTypes = ['video/mp4', 'video/webm'];
export const TextMimeTypes = ['application/xml', 'application/json', 'text/plain'];
export const ArchiveMimeTypes = ['application/zip', 'application/gzip', 'application/x-7z-compressed', 'application/vnd.rar'];
export const ExecuteMimeTypes = ['application/x-sega-cd-rom', 'application/vnd.android.package-archive'];

export type MimeTypes = 'audio/mp3' | 'audio/wav' | 'audio/mpeg' | 'image/png' | 'image/jpeg' | 'image/gif' | 'video/mp4' | 'video/webm' | 'application/xml' | 'application/json' | 'text/plain' | 'application/zip' | 'application/gzip' | 'application/x-7z-compressed' | 'application/vnd.rar' | 'application/x-sega-cd-rom' | 'application/vnd.android.package-archive';

export const ExecuteExtensions = ['exe', 'sh'];
export const ImageExtensions = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
export const AudioExtensions = ['mp3', 'wav'];
export const TextExtensions = ['txt', 'json', 'xml', 'md', 'js', 'css'];
export const VideoExtensions = ['mp4', 'avi', 'webm'];
export const ArchiveExtensions = ['zip', 'gz', '7z'];

export enum APIStatusCodes {
    HTTP_100_CONTINUE = 100,
    HTTP_101_SWITCHING_PROTOCOLS = 101,
    HTTP_102_PROCESSING = 102,

    HTTP_200_OK = 200,
    HTTP_201_CREATED = 201,
    HTTP_202_ACCEPTED = 202,

    HTTP_301_MOVED_PERMANENTLY = 301,
    HTTP_302_MOVED_TEMPORARILY = 302,
    HTTP_303_SEE_OTHER = 303,
    HTTP_304_NOT_MODIFIED = 304,
    HTTP_305_USE_PROXY = 305,
    HTTP_306_SWITCH_PROXY = 306,
    HTTP_307_TEMPORARY_REDIRECT = 307,
    HTTP_308_PERMANENT_REDIRECT = 308,

    HTTP_400_BAD_REQUEST = 400,
    HTTP_401_UNAUTHORIZED = 401,
    HTTP_403_FORBIDDEN = 403,
    HTTP_404_NOT_FOUND = 404,
    HTTP_405_METHOD_NOT_ALLOWED = 405,
    HTTP_406_NOT_ACCEPTABLE = 406,
    HTTP_408_REQUEST_TIMEOUT = 408,
    HTTP_409_CONFLICT = 409,
    HTTP_429_TOO_MANY_REQUESTS = 429,

    HTTP_500_INTERNAL_SERVER_ERROR = 500,
    HTTP_501_NOT_IMPLEMENTED = 501,
    HTTP_502_BAD_GATEWAY = 502,
    HTTP_503_SERVICE_UNAVAILABLE = 503,
    HTTP_504_GATEWAY_TIMEOUT = 504,
    HTTP_505_HTTP_VERSION_NOT_SUPPORTED = 505,
}

export interface ICreateHashRes {
    data: { product_uuid: string, usage: usage, price: number }
    hash: string
    message: string
    notification: { unread_notification: number, unread_message : number}
    responseTime: number
    statusCode: number
    success: boolean
}

export type usage = 'package' | "smart_complaint" |"custom_complaint" | "ready_complaint" | "offline_consultation" | "online_consultation" | "face_to_face_consultation" | "petition" | "learning" | "ready_contract" | "smart_contract" | "custom_contract" | "contract_expertise" | "contract_meeting" | "extra_question" | "custom_petition" | "ready_petition" | "declaration" | "bill" | "other_judicial_request" | "lawyer" | "course";

export type CheckedOptionType = [this: any, function: () => Promise<boolean>] | boolean;

export type ActiveRouteProperty = 'no-auth' | 'no-sidebar' | 'no-topbar' | 'has-footer';

export type ServiceType = 'petition' | 'course' | 'custom_contract' | 'ready_contract' | 'smart_contract' | 'article' | 'custom_complaint'|'ready_complaint'| 'ready_petition'| 'custom_petition' ;

export type PaymentProdauctType = 'charge_wallet' | 'purchase_products' | 'refund';

export type PaymentProductKind = 'offline_consultation' | 'online_consultation' | 'face_to_face_consultation' | 'custom_contract' | 'ready_contract' | 'smart_contract' | 'contract_meeting' | 'contract_expertise' | 'learning' | 'petition' | 'extra_question' | 'voip' | 'custom_complaint' | 'ready_complaint' | 'custom_petition' | 'ready_petition' | 'declaration' | 'bill' | 'other_judicial_request' | 'package';

export type SeoType = 'static' | 'search' | 'petition' | 'course' | 'contract' | 'complaint' | 'article'

export type LoadingTypes = 'standard' | 'hourglass' | 'circle' | 'arrows' | 'dots' | 'pulse'